import { useEffect, useState } from 'preact/hooks';

/**
 * Keeps an element mounted across its enter/exit transition. Returns `mounted`
 * (render the node while true) and `show` (toggle the `.show` styles).
 * Pattern: on open → mount, then flip `show` on the next frame so the transition
 * runs; on close → drop `show`, then unmount after `duration`.
 */
export function useMountTransition(open: boolean, duration = 200) {
  const [mounted, setMounted] = useState(open);
  const [show, setShow] = useState(open);

  useEffect(() => {
    let raf = 0;
    let timer = 0;
    if (open) {
      setMounted(true);
      raf = requestAnimationFrame(() => setShow(true));
    } else {
      setShow(false);
      timer = window.setTimeout(() => setMounted(false), duration);
    }
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, [open, duration]);

  return { mounted, show };
}
